import React from "react";
import "./UiDateInput.css";
import { useState } from "react";
import { useEffect } from "react";
import { ICON } from "../../../assets";
import UiIcon from "../UiIcon";

function UiDateInput({
  placeholder = "",
  value,
  onChange = () => {},
  style,
  className,
  name,
  errorMessage,
  readOnly = false,
  icon = ICON.errorIcon,
  throwError = false,
  required = false,
}) {
  const [error, setError] = useState(null);
  const [waitforclick, setWaitforclick] = useState(false);
  const [inputValue, setInputValue] = useState(value);

  const throwErrorData = () => {
    if (inputValue && inputValue.length === 10) {
      const [year, month, day] = value?.split("-");
      const date = new Date(`${year}-${month}-${day}`);
      if (
        date &&
        date.getFullYear() === parseInt(year) &&
        date.getMonth() + 1 === parseInt(month) &&
        date.getDate() === parseInt(day)
      ) {
        setError("Veuillez saisir une date valide au format DD / mm / Yyyy");
        return false;
      }
    }
    return true;
  };

  useEffect(() => {
    if (throwError && required) {
      setError(errorMessage || "Ce champ est obligatoire");
      return;
    }
    if (!inputValue && errorMessage && waitforclick && !readOnly) {
      setError(errorMessage);
      return;
    } else {
      setError(null);
    }
    if (!readOnly) throwErrorData() && setError(null);
  }, [inputValue, waitforclick, errorMessage, throwError]);

  const handleChange = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let { name, value } = e.target;
    if (value && value.length === 10) {
      const [year, month, day] = value?.split("-");
      value = new Date(`${year}-${month}-${day}`);
    }
    onChange({ name, value });
    setInputValue(value);
  };

  return (
    <React.Fragment>
      <div
        className={`ui-date-input-container ${className || ""}`}
        style={style}
      >
        <input
          type="date"
          className={`ui-date-input-field ${error ? "error" : ""}`}
          placeholder={placeholder}
          onChange={handleChange}
          name={name}
          readOnly={readOnly}
          onBlur={() => setWaitforclick(true)}
        />
        {error && (
          <div className="error-message">
            {icon && <UiIcon icon={icon} alt="error icon" size="md" />}
            <span>{error}</span>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default UiDateInput;
